import React, { Component } from 'react';
import Prismic from "prismic-javascript";
import { PrismicConfig } from "../../helpers/prismicHelpers/PrismicAPI";
import { trustedByBarHelper } from "../../helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/sliceTrustedByBarSlice";
import Loader from "../common/elements/Loader";

export default class TrustedByBarSlice extends Component {
    state = {
        data: false,
        error: false
    };

    async componentDidMount() {
        try {
            const res = await Prismic.api(PrismicConfig.apiEndpoint, {
                accessToken: PrismicConfig.apiAccessToken
            });
            const json = await Promise.all([
                res.query(Prismic.Predicates.at("document.type", "trusted-by-bar"))
            ]);
            this.setState({ data: trustedByBarHelper(json[0]) });
        } catch (err) {
            this.setState({ error: true });
        }
    }

    render() {
        const { data, error } = this.state;

        if (!data || !data.trustedByBar) return  <Loader />;
        if (error) return "";

        return (
            <section
                className="features-bar features-bar--trusted-by padding-top padding-bottom"
                style={{
                    backgroundColor: data.trustedByBar.bg_color,
                    color: data.trustedByBar.text_color
                }}
            >
                <div className="container">
                    <div className="row flex-container--row">
                        {data.trustedByBar.title && data.trustedByBar.title.length > 0 && (
                            <div className="align-content-center align-items-center flex-column--text">
                                <h4 className="h4 title">{data.trustedByBar.title}</h4>
                            </div>
                        )}
                        <div className="flex-column--image-container">
                            <div className="flex-container--row">
                                {data.trustedByBar.companies.map((company, index) => (
                                    <div 
                                        className="flex-column--image"
                                        key={index}
                                    >
                                        <img
                                            className="trusted-logo"
                                            width="100%"
                                            src={company.logo}
                                            alt={company.alternative_text_photo}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// src/client/components/slices/TrustedByBarSlice.js